// Hook
import { useEffect, useRef, useState } from 'react';

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const useGetCountryFromIP = () => {
  const [ country, setCountry ] = useState(null);
  const [ loaded, setLoaded ] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch('https://api.country.is').then((resp) => {
          return resp.json();
        }).catch(() => {
          return 'GR';
        });

        let parsedCountry;

        if (null == response) {
          parsedCountry = 'GR';
        } else {
          parsedCountry = 'GR' === response.country ? 'GR' : 'US';
        }

        setCountry(parsedCountry);
      } catch {
        setCountry('GR');
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  return { country, loaded };
};

export function useDebounce(value, delay) {
  const [ debouncedValue, setDebouncedValue ] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [ value, delay ]);
  return debouncedValue;
}
